/**

 * 线上静态资源根路径（与 OSS guangwan/img 下目录结构一致）

 */

export const IMG_CDN_BASE = 'https://fs-center.oss-cn-shenzhen.aliyuncs.com/guangwan/img/'



/** 拼接 CDN 地址，支持子目录；各段路径自动 URL 编码 */

export function cdnImg(filename) {

	if (!filename) return ''

	const name = String(filename).replace(/^\//, '')

	const encoded = name.split('/').map((seg) => encodeURIComponent(seg)).join('/')

	return IMG_CDN_BASE + encoded

}



/** 各内页 Banner（OSS 根目录同名 jpg） */

export const pageBanners = {

	companyIntroduction: cdnImg('公司介绍.jpg'),

	jobChance: cdnImg('工作机会.jpg'),

	newsInformation: cdnImg('新闻动态.jpg'),

	service: cdnImg('相关服务.jpg'),

	hardwareProducts: cdnImg('硬件产品.jpg'),

	contactUs: cdnImg('联系我们.jpg'),

	softwareMindMaps: cdnImg('软件导图.jpg')

}




// WEBPACK FOOTER //
// ./src/config/imgBase.js